import React from "react";

// components



export default function Leads() {
  return (
    <>
      <div className="flex flex-wrap">
        hi its leads
      </div>
    </>
  );
}
